// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__y-Qma","list":"styles_list__3uYSf"};